<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page fingerprint-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar bbm-avatar-contain">
            <img
              src="/assets/fingerprint.png"
              [alt]="'fingerprint' | transloco"
            >
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'fingerprint' | transloco }}
            </span>

            <h2>
              {{
                hasCheckedIn && !hasCheckedOut
                  ? ('check out' | transloco)
                  : ('check in' | transloco)
              }}
            </h2>
          </div>

        </div>

        <span
          class="bbm-status-pill"
          [class.bbm-status-success]="hasCheckedIn && hasCheckedOut"
          [class.bbm-status-warning]="hasCheckedIn && !hasCheckedOut"
          [class.bbm-status-primary]="!hasCheckedIn"
        >
          {{
            hasCheckedIn && hasCheckedOut
              ? ('check out' | transloco)
              : (
                  hasCheckedIn
                    ? ('check in' | transloco)
                    : ('check in' | transloco)
                )
          }}
        </span>

      </div>

      <!-- HERO ACTIONS -->
      <div class="bbm-actions-grid bbm-actions-three bbm-hero-actions noPrint">

        <button
          type="button"
          class="bbm-action-btn bbm-action-primary bbm-action-wide"
          *ngIf="!hasCheckedIn"
          (click)="getLocationAndCheck('in')"
          [disabled]="!canCheckIn"
        >
          <i class="fa-solid fa-fingerprint"></i>

          <span>
            {{ 'check in' | transloco }}
          </span>
        </button>

        <button
          type="button"
          class="bbm-action-btn bbm-action-danger"
          *ngIf="hasCheckedIn"
          (click)="getLocationAndCheck('out')"
          [disabled]="!canCheckIn || hasCheckedOut"
        >
          <i class="fa-solid fa-right-from-bracket"></i>

          <span>
            {{ 'check out' | transloco }}
          </span>
        </button>

        <button
          type="button"
          class="bbm-action-btn bbm-action-primary"
          *ngIf="canCheckIn"
          (click)="scanMode = !scanMode"
        >
          <i class="fa-solid fa-qrcode"></i>

          <span>
            {{ 'scan QR' | transloco }}
          </span>
        </button>

        <button
          type="button"
          class="bbm-action-btn"
          *ngIf="isAdmin"
          (click)="QrOption = !QrOption"
        >
          <i class="fa-solid fa-gear"></i>

          <span>
            {{ 'options' | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- QR OPTIONS -->
    <section
      *ngIf="QrOption"
      class="bbm-form-ticket noPrint"
    >

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'fingerprint' | transloco }}
          </span>

          <h3>
            {{ 'scan QR' | transloco }}
          </h3>
        </div>

        <button
          type="button"
          *ngIf="isAdmin"
          class="bbm-action-btn bbm-action-success bbm-action-compact"
          (click)="generateQr()"
        >
          <i class="fa-solid fa-plus"></i>

          <span>
            {{ 'Create QR Code' | transloco }}
          </span>
        </button>
      </div>

      <div
        class="bbm-qr-grid"
        *ngIf="qrList?.length; else emptyQr"
      >

        <article
          *ngFor="let qr of qrList"
          class="bbm-ticket bbm-qr-card"
        >

          <div class="bbm-qr-preview">
            <img
              [src]="fixImageUrl(qr.qr_url)"
              [alt]="'QR Code' | transloco"
            >
          </div>

          <div class="bbm-actions-grid">

            <button
              type="button"
              class="bbm-action-btn bbm-action-primary"
              (click)="downloadQr(fixImageUrl(qr.qr_url))"
            >
              <i class="fa-solid fa-download"></i>

              <span>
                {{ 'Download QR' | transloco }}
              </span>
            </button>

            <button
              type="button"
              class="bbm-action-btn bbm-action-danger"
              (click)="deleteQr(qr.id)"
            >
              <i class="fa-regular fa-trash-can"></i>

              <span>
                {{ 'Delete' | transloco }}
              </span>
            </button>

          </div>

        </article>

      </div>

      <ng-template #emptyQr>
        <div class="bbm-empty-state">
          <i class="fa-solid fa-qrcode"></i>

          <h4>
            {{ 'scan QR' | transloco }}
          </h4>

          <p>-</p>
        </div>
      </ng-template>

    </section>

    <!-- SCANNER -->
    <section
      *ngIf="scanMode"
      class="bbm-form-ticket noPrint"
    >

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'fingerprint' | transloco }}
          </span>

          <h3>
            {{ 'scan QR' | transloco }}
          </h3>
        </div>

        <button
          type="button"
          class="bbm-action-btn bbm-action-danger bbm-icon-action"
          (click)="scanMode = false"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="bbm-media-frame">
        <zxing-scanner
          [formats]="allowedFormats"
          (scanSuccess)="onCodeResult($event)"
        >
        </zxing-scanner>
      </div>

    </section>

    <!-- FILTERS -->
    <section class="bbm-form-ticket noPrint">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'fingerprint' | transloco }}
          </span>

          <h3>
            {{ 'bymonth' | transloco }}
          </h3>
        </div>
      </div>

      <div class="bbm-form-grid">

        <!-- YEAR -->
        <div class="bbm-field">
          <label for="attendance-year">
            {{ 'bymonth' | transloco }}
          </label>

          <select
            id="attendance-year"
            class="bbm-control"
            [(ngModel)]="selectedYear"
            (change)="loadAttendance()"
          >
            <option
              *ngFor="let year of years"
              [value]="year"
            >
              {{ year }}
            </option>
          </select>
        </div>

        <!-- MONTH -->
        <div class="bbm-field">
          <label for="attendance-month">
            {{ 'bymonth' | transloco }}
          </label>

          <select
            id="attendance-month"
            class="bbm-control"
            [(ngModel)]="selectedMonth"
            (change)="loadAttendance()"
          >
            <option
              *ngFor="let month of months"
              [value]="month.value"
            >
              {{ isAr ? month.name_ar : month.name_en }}
            </option>
          </select>
        </div>

        <!-- USER -->
        <div
          class="bbm-field bbm-field-wide"
          *ngIf="hasaccess"
        >
          <label for="attendance-user">
            {{ 'Users' | transloco }}
          </label>

          <select
            id="attendance-user"
            class="bbm-control"
            [(ngModel)]="selectedUserId"
            (change)="userFilter(selectedUserId)"
          >
            <option
              *ngFor="let el of allUsers"
              [value]="el.id"
            >
              {{ el.first_name }} {{ el.last_name }}
            </option>
          </select>
        </div>

      </div>

    </section>

    <!-- ATTENDANCE LIST -->
    <section>

      <div class="bbm-list-head">
        <div>
          <span>
            {{ 'fingerprint' | transloco }}
          </span>

          <h3>
            {{ 'fingerprint' | transloco }}
          </h3>
        </div>

        <span class="bbm-list-counter">
          {{ attendanceData?.length || 0 }}
        </span>
      </div>

      <!-- EMPTY STATE -->
      <div
        class="bbm-empty-state"
        *ngIf="
          !contentReady &&
          (!attendanceData || attendanceData.length === 0)
        "
      >
        <i class="fa-regular fa-calendar-xmark"></i>

        <h4>
          {{ 'fingerprint' | transloco }}
        </h4>

        <p>-</p>
      </div>

      <!-- ATTENDANCE CARDS -->
      <div class="bbm-ticket-list">

        <article
          class="bbm-ticket"
          *ngFor="let record of attendanceData"
        >

          <!-- CARD TOP -->
          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                <i class="fa-regular fa-calendar"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ 'Date' | transloco }}
                </span>

                <h3>
                  {{ record.date }}
                </h3>
              </div>

            </div>

            <span
              *ngIf="isAdmin"
              class="bbm-status-pill"
              [class.bbm-status-success]="record.location_access_denied == 0"
              [class.bbm-status-danger]="record.location_access_denied == 1"
            >
              {{
                record.location_access_denied
                  ? ('locationrejected' | transloco)
                  : ('access' | transloco)
              }}
            </span>

          </div>

          <!-- ATTENDANCE TIMES -->
          <div class="bbm-details-grid">

            <div class="bbm-detail-chip bbm-detail-success">
              <i class="fa-solid fa-right-to-bracket"></i>

              <span>
                {{ 'check in' | transloco }}
              </span>

              <strong>
                {{ record.check_in_device_time || '-' }}
              </strong>
            </div>

            <div class="bbm-detail-chip bbm-detail-danger">
              <i class="fa-solid fa-right-from-bracket"></i>

              <span>
                {{ 'check out' | transloco }}
              </span>

              <strong>
                {{ record.check_out_device_time || '-' }}
              </strong>
            </div>

            <div class="bbm-detail-chip bbm-detail-primary bbm-detail-wide">
              <i class="fa-solid fa-hourglass-half"></i>

              <span>
                {{ 'workingtime' | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{
                  calculateDiff(
                    record.check_in_device_time,
                    record.check_out_device_time
                  )
                }}
              </strong>
            </div>

          </div>

          <!-- ADMIN DETAILS -->
          <div
            class="bbm-details-grid attendance-admin-details"
            *ngIf="isAdmin"
          >

            <!-- DEVICE -->
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-mobile-screen"></i>

              <span>
                {{ 'device' | transloco }}
              </span>

              <div class="bbm-detail-value">
                <strong>
                  {{ record.ip_address || '-' }}
                </strong>

                <p>
                  {{ extractDeviceInfo(record.device_info) || '-' }}
                </p>
              </div>
            </div>

            <!-- LOCATION -->
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-location-dot"></i>

              <span>
                {{ 'location' | transloco }}
              </span>

              <div class="bbm-detail-value bbm-link-stack">

                <a
                  *ngIf="
                    record.check_in_latitude &&
                    record.check_in_longitude
                  "
                  class="bbm-action-btn bbm-action-call"
                  target="_blank"
                  rel="noopener noreferrer"
                  [href]="
                    'https://www.google.com/maps?q=' +
                    record.check_in_latitude +
                    ',' +
                    record.check_in_longitude
                  "
                >
                  <i class="fa-solid fa-location-arrow"></i>

                  <span>
                    {{ 'check in' | transloco }} -
                    {{ 'map location' | transloco }}
                  </span>
                </a>

                <a
                  *ngIf="
                    record.check_out_latitude &&
                    record.check_out_longitude
                  "
                  class="bbm-action-btn bbm-action-call"
                  target="_blank"
                  rel="noopener noreferrer"
                  [href]="
                    'https://www.google.com/maps?q=' +
                    record.check_out_latitude +
                    ',' +
                    record.check_out_longitude
                  "
                >
                  <i class="fa-solid fa-location-arrow"></i>

                  <span>
                    {{ 'check out' | transloco }} -
                    {{ 'map location' | transloco }}
                  </span>
                </a>

                <p
                  *ngIf="
                    !record.check_in_latitude &&
                    !record.check_in_longitude &&
                    !record.check_out_latitude &&
                    !record.check_out_longitude
                  "
                >
                  -
                </p>

              </div>
            </div>

            <!-- SERVER TIME -->
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-clock"></i>

              <span>
                {{ 'server time' | transloco }}
              </span>

              <div class="bbm-detail-value">
                <p>
                  <strong>
                    {{ 'check in' | transloco }}:
                  </strong>

                  {{ record.check_in_server_time || '-' }}
                </p>

                <p>
                  <strong>
                    {{ 'check out' | transloco }}:
                  </strong>

                  {{ record.check_out_server_time || '-' }}
                </p>
              </div>
            </div>

          </div>

        </article>

      </div>

    </section>

  </div>
</div>
